export function RouteFallback() {
  return (
    <div
      className="flex min-h-[100dvh] items-center justify-center px-4 py-12"
      role="status"
      aria-live="polite"
      aria-label="Loading page"
    >
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#801520] border-t-transparent" />
    </div>
  );
}

export default RouteFallback;
